import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
export default function isPromise(object) {
  return _Promise.resolve(object) === object;
}